export const hhmm = (timestamp: number) => {
	const moment = require("moment");
	return moment(timestamp).format("HH:mm");
};
